import React from 'react';
import { Outlet } from 'react-router';
import Header from 'components/Sections/Header';
import Footer from 'components/Sections/Footer';
import PropTypes from 'prop-types';

function AuthLayout({ isB2cPage })
{
    return (
        <>
            <Header isB2cPage={isB2cPage} />
            <Outlet />
            <Footer />
        </>
    );
}

AuthLayout.defaultProps = {
    isB2cPage: false,
};
AuthLayout.propTypes = {
    isB2cPage: PropTypes.bool,
};

export default AuthLayout;
